import { configureStore } from "@reduxjs/toolkit";
import SnackBarReducer from "./SnackBar";
import classRequestReducer from "./ClassRequest";
import parentClientReducer from "./parentClient";
import generalStoreReducer from "./GeneralStore";
import rosterConifgRecucer from "./RosterConfig";
import bulkEditReducer from "./BulkEdit";
import askNowReducer from "./AskNowTicket";
import assignTrainee from "./AssignTrainee";
import addNonHRMSEmployee from "./addNonHRMSEmployee";
import viewDetailsReducer from "./ViewDetails";
import obtInfoManagement from "./obtInfoManagement";

const store = configureStore({
  reducer: {
    askNow: askNowReducer,
    snackBar: SnackBarReducer,
    bulkEdit: bulkEditReducer,
    classRequest: classRequestReducer,
    parentClientId: parentClientReducer,
    generalStore: generalStoreReducer,
    rosterConfig: rosterConifgRecucer,
    viewDetails: viewDetailsReducer,
    assignTrainees: assignTrainee,
    addNonHRMSEmployee: addNonHRMSEmployee,
    obtInfoManagement: obtInfoManagement,
  },
});

export default store;
